import { get, post } from '../https.js'

/**
  * 新增定向包
  * @param {*} data
  * @returns
  */
export const packageadd = (data) => post('/r1/package/add', data)

/**
  * 修改定向包
  * @param {*} data
  * @returns
  */
export const packageupdate = (data) => post('/r1/package/update', data)

/**
  * 删除定向包
  * @param {*} data
  * @returns
  */
export const packagedelete = (data) => get('/r1/package/delete', data)


/**
  * 分页查询当前登录用户的定向包列表
  * @param {*} data
  * @returns
  */
export const packagelist = (data) => get('/r1/package/list', data)

/**
  * 地域下拉查询（地域内置，不分页）
  * @param {*} data
  * @returns
  */
export const regionList = (data) => get('/r1/package/regionList', data)


/**
  * 分页查询当前登录用户的标题
  * @param {*} data
  * @returns
  */
export const titlePackagelist = (data) => get('/r1/titlePackage/list', data)


/**
  * 分页查询当前登录用户的标题库
  * @param {*} data
  * @returns
  */
export const titlePackagegroupList = (data) => get('/r1/titlePackage/groupList', data)

/**
  * 批量添加标题
  * @param {*} data
  * @returns
  */
export const titlePackageaddBatch = (data) => post('/r1/titlePackage/addBatch', data)

/**
  * 批量删除标题，传一个id时即为单条删除
  * @param {*} data
  * @returns
  */
export const titlePackagedeleteBatch = (data) => post('/r1/titlePackage/deleteBatch', data)


/**
  * 分页查询当前登录人的产品主图
  * @param {*} data
  * @returns
  */
export const productMainImagelist = (data) => get('/r1/productMainImage/list', data)

/**
  * 根据id删除
  * @param {*} data
  * @returns
  */
export const productMainImagedelete = (data) => get('/r1/productMainImage/delete', data)

/**
  * 添加产品主图
  * @param {*} data
  * @returns
  */
export const productMainImageadd = (data) => post('/r1/productMainImage/add', data)

/**
  * 上传产品图
  * @param {*} data
  * @returns
  */
export const productMainImageuploadProductImage = (data) => post('/r1/productMainImage/uploadProductImage', data)


/**
  * 按组织ID同步账户（递归）：
  * @param {*} data
  * @returns
  */
export const teamAccountsyncByOrgId2 = (data) => get('/r1/teamAccount/syncByOrgId2', data)


/**
  * 同步所有超管账户下的团队账户
  * @param {*} data
  * @returns
  */
export const teamAccountsyncAll = (data) => get('/r1/teamAccount/syncAll', data)

/**
  * 组织树：超管账户为一级组织，其下 depth=1 的团队为二级，依次类推
  * @param {*} data
  * @returns
  */
export const teamAccounttree = (data) => get('/r1/teamAccount/tree', data)

/**
  * 按组织ID同步账户（递归）：
  * @param {*} data
  * @returns
  */
export const teamAccountlist = (data) => get('/r1/teamAccount/list', data)


/**
  * 手动批量添加短剧
  * @param {*} data
  * @returns
  */
export const bookaddBatch = (data) => post('/r1/book/addBatch', data)


/**
  * 分销平台下拉框（查询所有启用的平台）
  * @param {*} data
  * @returns
  */
export const bookplatformList = (data) => get('/r1/book/platformList', data)


/**
  * 短剧分页查询
  * @param {*} data
  * @returns
  */
export const booklist = (data) => post('/r1/book/list', data)


/**
  * 推广链接查询
  * @param {*} data
  * @returns
  */
export const bookpromotionList = (data) => get('/r1/book/promotionList', data)


/**
  * 手动添加推广链接（兜底）
  * @param {*} data
  * @returns
  */
export const bookaddPromotion = (data) => post('/r1/book/addPromotion', data)


/**
  * 番茄获取付费剧目可用面板参数
  * @param {*} data
  * @returns
  */
export const fanqiepurchasePanel = (data) => get('/r1/fanqie/purchasePanel', data)

/**
  * 番茄获取免费剧目可用广告解锁集
  * @param {*} data
  * @returns
  */
export const fanqieadPanel = (data) => get('/r1/fanqie/adPanel', data)

/**
  * 番茄生成推广链接（参数均由前端传入，成功后落库 yly_drama_promotion）
  * @param {*} data
  * @returns
  */
export const fanqiecreatePromotion = (data) => post('/r1/fanqie/createPromotion', data)


// /**
//   * 上传记录查询
//   * @param {*} data
//   * @returns
//   */
// export const sucaiSelectList = (data) => post('/yly/sucai/selectList', data)

/**
  * 创建文件夹
  * @param {*} data
  * @returns
  */
export const foldercreate = (data) => post('/yly/folder/create', data)

/**
  * 修改文件夹（改名/移动）
  * @param {*} data
  * @returns
  */
export const folderupdate = (data) => post('/yly/folder/update', data)

/**
  * 查询当前登录人部门及其下级部门树(共享选部门)
  * @param {*} data
  * @returns
  */
export const folderdeptTree = (data) => post('/yly/folder/deptTree', data)

/**
  * 查询部门下人员（共享选人）
  * @param {*} data
  * @returns
  */
export const folderdeptUsers = (data) => post('/yly/folder/deptUsers', data)

/**
  * 创建共享（部门/个人）
  * @param {*} data
  * @returns
  */
export const foldershareSave = (data) => post('/yly/folder/share/save', data)

/**
  * 取消共享
  * @param {*} data
  * @returns
  */
export const foldershareDelete = (data) => post('/yly/folder/share/delete', data)

/**
  * 查询某文件夹的共享列表
  * @param {*} data
  * @returns
  */
export const foldershareList = (data) => post('/yly/folder/share/list', data)

/**
  * 上传记录查询
  * @param {*} data
  * @returns
  */
export const sucaiSelectList = (data) => post('/yly/sucai/selectList', data)

/**
  * 删除文件夹（递归删除子文件夹及共享关系）
  * @param {*} data
  * @returns
  */
export const folderdelete = (data) => post('/yly/folder/delete', data)

/**
  * 查询文件夹树（当前登录人可见范围；也可按部门查）
  * @param {*} data
  * @returns
  */
export const foldertree = (data) => post('/yly/folder/tree', data)



/**
  * 异步上传视频到巨量开放平台
  * @param {*} data
  * @returns
  */
export const juliangvideoupload = (data) => post('/yly/sucai/juliang/video/upload', data)


/**
  * 根据素材ID批量删除素材
  * @param {*} data
  * @returns
  */
export const sucaideleteByIds = (data) => post('/yly/sucai/deleteByIds', data)


/**
  * 获取组织维度视频列表（EBP，实时调用巨量开放平台接口，透传分页信息）
  * @param {*} data
  * @returns
  */
export const sucaiEbpVideoList = (data) => post('/yly/sucai/ebp/video/list', data)


/**
  * 获取账户维度视频列表（EBP，按账户反查所属组织并解析access_token，实时调用
  * @param {*} data
  * @returns
  */
export const sucaiEbpVideoListByAdvertiser = (data) => post('/yly/sucai/ebp/video/listByAdvertiser', data)



/**
  * 商品库分页查询
  * @param {*} data
  * @returns
  */
export const librarylist = (data) => get('/r1/library/list', data)

/**
  * 同步商品库列表（调用巨量接口拉取后入库）
  * @param {*} data
  * @returns
  */
export const librarysync = (data) => post('/r1/library/sync', data)


/**
  * 新建通用版商品（批量剧目ID逐条异步调用巨量接口）
  * @param {*} data
  * @returns
  */
export const libraryproductCreate = (data) => post('/r1/library/productCreate', data)


/**
  * 新建商品任务分页查询
  * @param {*} data
  * @returns
  */
export const librarycreateTaskList = (data) => post('/r1/library/createTaskList', data)



/**
  * 保存新建商品策略（前端点击"保存策略"按钮时调用，未点击不保存）
  * @param {*} data
  * @returns
  */
export const librarystrategySave = (data) => post('/r1/library/strategySave', data)



/**
  * 策略分页查询（仅当前登录人保存的策略）
  * @param {*} data
  * @returns
  */
export const librarystrategyList = (data) => get('/r1/library/strategyList', data)


/**
  * 短剧导出（异步）：按筛选条件导出 Excel 到 OSS（drama/ 目录）
  * @param {*} data
  * @returns
  */
export const bookexport = (data) => post('/r1/book/export', data)

/**
  * 导出任务列表：创建人名称、任务ID、下载地址、导出创建时间（按导出时间倒序）
  * @param {*} data
  * @returns
  */
export const bookexportTaskPage = (data) => get('/r1/book/exportTaskPage', data)


/**
  * 分页查询当前登录人的抖音号信息
  * @param {*} data
  * @returns
  */
export const douyinAccountlist = (data) => get('/r3/douyinAccount/list', data)


/**
  * 批量删除抖音号
  * @param {*} data
  * @returns
  */
export const douyinAccountdeleteByIds = (data) => post('/r3/douyinAccount/deleteByIds', data)


/**
  * 添加抖音号
  * @param {*} data
  * @returns
  */
export const douyinAccountadd = (data) => get('/r3/douyinAccount/add', data)


/**
  * 添加全域广告投放配置
  * @param {*} data
  * @returns
  */
export const globalAdConfigadd = (data) => post('/r3/globalAdConfig/add', data)


/**
  * 批量校验账户ID是否存在于 yly_team_account
  * @param {*} data
  * @returns
  */
export const globalAdConfigcheckAccounts = (data) => post('/r3/globalAdConfig/checkAccounts', data)


/**
  * 校验全域创编可用抖音号（账户×短剧 叉乘组合）
  * @param {*} data
  * @returns
  */
export const globalAdConfigcheckDouyinAvailable = (data) => post('/r3/globalAdConfig/checkDouyinAvailable', data)



/**
  * 获取通用版商品列表（实时调用巨量开放平台接口，透传分页信息）
  * @param {*} data
  * @returns
  */
export const libraryebpProductList = (data) => get('/r1/library/ebpProductList', data)




/**
  * 同步通用版商品入库(异步分页拉取该商品库全部商品，按商品库ID+商品ID唯- upsert)
  * @param {*} data
  * @returns
  */
export const libraryebpProductSync = (data) => get('/r1/library/ebpProductSync', data)



/**
  * 分页查询（带任务详情统计）：配置名称模糊查询，返回配置名称/status/任务详情
  * @param {*} data
  * @returns
  */
export const globalAdConfigpageWithTaskStats = (data) => get('/r3/globalAdConfig/pageWithTaskStats', data)



/**
  * 按配置ID查询任务详情，支持按状态过滤，默认不传返回全部
  * @param {*} data
  * @returns
  */
export const globalAdConfigtasks = (data) => get('/r3/globalAdConfig/tasks', data)


/**
  * 校验全域创编可用抖音号（账户×短剧 叉乘组合）
  * @param {*} data
  * @returns
  */
export const globalAdConfigCheckDouyinAvailable = (data) => post('/r3/globalAdConfig/checkDouyinAvailable', data)




// 项目=》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》
/**
  * 账户报表按天：每天 x 账户一行（名下项目求和），accountId 只作筛选
  * @param {*} data
  * @returns
  */
export const projectReportPageAccountByDay = (data) => post('/r3/projectReport/pageAccountByDay', data)



/**
  * 账户报表按月：一账户一行（名下项目求和），accountId 只作筛选
  * @param {*} data
  * @returns
  */
export const projectReportPageAccountByMonth = (data) => post('/r3/projectReport/pageAccountByMonth', data)



/**
  * 账户下项目明细按天：每天 x 账户 x 项目一行，点击账户后调用，accountId 只作筛选
  * @param {*} data
  * @returns
  */
export const projectReportPageProjectByDay = (data) => post('/r3/projectReport/pageProjectByDay', data)



/**
  * 账户下项目明细按月：账户 x 项目汇总一行，点击账户后调用，accountId 只作筛选
  * @param {*} data
  * @returns
  */
export const projectReportPageProjectByMonth = (data) => post('/r3/projectReport/pageProjectByMonth', data)


/**
  * 手动补数：把某天火山项目聚合重同步到本地汇总表
  * @param {*} data
  * @returns
  */
export const projectReportsync = (data) => get('/r3/projectReport/sync', data)


/**
  * 账户报表按天总数：与 pageAccountByDay 同逻辑，区间内全部数据汇总成一行
  * @param {*} data
  * @returns
  */
export const projectReporttotalAccountByDay = (data) => post('/r3/projectReport/totalAccountByDay', data)


/**
  * 账户报表按月总数：与 pageAccountByMonth 同逻辑，区间内全部数据汇总成一行
  * @param {*} data
  * @returns
  */
export const projectReporttotalAccountByMonth = (data) => post('/r3/projectReport/totalAccountByMonth', data)


/**
  * 账户下项目明细按天总数：与 pageProjectByDay 同逻辑，区间内全部数据汇总成一行
  * @param {*} data
  * @returns
  */
export const projectReporttotalProjectByDay = (data) => post('/r3/projectReport/totalProjectByDay', data)


/**
  * 账户下项目明细按月总数：与 pageProjectByMonth 同逻辑，区间内全部数据汇总成
  * @param {*} data
  * @returns
  */
export const projectReporttotalProjectByMonth = (data) => post('/r3/projectReport/totalProjectByMonth', data)


/**
  * 查询配置详情（含短剧/商品、素材，requestParam 原样返回）
  * @param {*} data
  * @returns
  */
export const globalAdConfigdetail = (data) => get('/r3/globalAdConfig/detail', data)

















// 素材=》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》

/**
  * 按天：每天 x 账户 x 素材 一行
  * @param {*} data
  * @returns
  */
export const materialReportPageByDay = (data) => post('/r3/materialReport/pageByDay', data)



/**
  * 按月：区间内按 账户 x 素材 汇总一行
  * @param {*} data
  * @returns
  */
export const materialReportPageByMonth = (data) => post('/r3/materialReport/pageByMonth', data)



/**
  * 手动补数：把某天火山素材聚合重同步到本地汇总表
  * @param {*} data
  * @returns
  */
export const materialReportSync = (data) => get('/r3/materialReport/sync', data)



/**
  * 按天总数：与 pageByDay 同样的权限/筛选/分表逻辑，把区间内全部数据汇总成一行
  * @param {*} data
  * @returns
  */
export const materialReporttotalByDay = (data) => post('/r3/materialReport/totalByDay', data)




/**
  * 按月总数：与 pageByMonth 同样的权限/筛选/分表逻辑，把区间内全部数据汇总成一行
  * @param {*} data
  * @returns
  */
export const materialReporttotalByMonth = (data) => post('/r3/materialReport/totalByMonth', data)



/**
  * 获取推广链列表并落库 yly_drama_promotion（type=1 自动拉取，remark=自动
  * @param {*} data
  * @returns
  */
export const fanqiesyncPromotionList = (data) => post('/r1/fanqie/syncPromotionList', data)



/**
  * 添加组织：body{"sid": 1, "teamId": 123, "remark": "备注"}
  * @param {*} data
  * @returns
  */
export const juliangmeitivideopullSave = (data) => post('/yly/juliangmeiti/video-pull/save', data)



/**
  * 共享组织给部门：body{"configId": 1, "shareDeptIds": [10, 11]}，传空数组即取消全部共享
  * @param {*} data
  * @returns
  */
export const juliangmeitivideopullShare = (data) => post('/yly/juliangmeiti/video-pull/share', data)



/**
  * 我可见的组织：我添加的 + 共享给我的（含上级共享下级继承）
  * @param {*} data
  * @returns
  */
export const juliangmeitivideopullmylist = (data) => post('/yly/juliangmeiti/video-pull/my-list', data)


/**
  * 删除组织：body{"id": 1}，仅添加人可删
  * @param {*} data
  * @returns
  */
export const juliangmeitivideopullDelete = (data) => post('/yly/juliangmeiti/video-pull/delete', data)



/**
  * 取消共享(单选)：body{"configId": 1, "shareDeptIds": [10]}
  * @param {*} data
  * @returns
  */
export const juliangmeitivideopullUnshare = (data) => post('/yly/juliangmeiti/video-pull/unshare', data)




/**
  * 获取全域投放项目列表
  * @param {*} data
  * @returns
  */
export const projectUniProjectList = (data) => post('/r3/project/uniProjectList', data)




/**
  * 批量添加投放项目下素材
  * @param {*} data
  * @returns
  */
export const projectbatchAddMaterial = (data) => post('/r3/project/batchAddMaterial', data)




/**
  * 获取视频素材
  * @param {*} data
  * @returns
  */
export const sucaivideomateriallist = (data) => post('/yly/sucai/video/material/list', data)





/**
  * 添加组织到主表：仅传 teamId
  * @param {*} data
  * @returns
  */
export const teamshareowneradd = (data) => get('/r1/team/share/owner/add', data)


/**
  * 当前登录人(或其部门及下属部门)可见的巨量组织树。
  * @param {*} data
  * @returns
  */
export const teamshareteamTree = (data) => get('/r1/team/share/teamTree', data)


/**
  * 从主表删除组织(按 teamId)。
  * @param {*} data
  * @returns
  */
export const teamshareownerdelete = (data) => get('/r1/team/share/owner/delete', data)


/**
  * 新增共享：把已加入主表的巨量组织 teamId 直接共享给内部部门 deptId
  * @param {*} data
  * @returns
  */
export const teamshareadd = (data) => get('/r1/team/share/add', data)


/**
  * 根据组织ID(team_id)查询该组织已共享的部门信息(含部门名称)。
  * @param {*} data
  * @returns
  */
export const teamshareshareInfoByOwner = (data) => get('/r1/team/share/shareInfoByTeamId', data)


/**
  * 取消共享：删除 teamId -> deptId 直接共享关系。
  * @param {*} data
  * @returns
  */
export const teamsharecancel = (data) => get('/r1/team/share/cancel', data)


/**
  * 账户查岗：判断这批账户是否属于当前登录人自己的组织，或属于共享给他的组织
  * @param {*} data
  * @returns
  */
export const teamsharecheckAccounts = (data) => post('/r1/team/share/checkAccounts', data)


/**
  * 根据组织ID同步工作组织关系入库
  * @param {*} data
  * @returns
  */
export const teamsyncByOrgId = (data) => get('/r1/team/syncByOrgId', data)


/**
  * 上传记录查询：仅查当前登录人创建的，可按文件名模糊、素材ID精确、状态筛选
  * @param {*} data
  * @returns
  */
export const sucaijuliangvideopushRecords = (data) => post('/yly/sucai/juliang/video/pushRecords', data)


/**
  * 追投素材日志分页查询
  * @param {*} data
  * @returns
  */
export const projectaddMaterialLogPage = (data) => post('/r3/project/addMaterialLogPage', data)


/**
  * 批量追加素材
  * @param {*} data
  * @returns
  */
export const projectbatchUniProjectList = (data) => post('/r3/project/batchUniProjectList', data)


/**
  * 同步全域项目到本地
  * @param {*} data
  * @returns
  */
export const projectSyncUniProject = (data) => post('/r3/project/syncUniProject', data)

/**
  * 本地同步项目分页查询（只查当前登录人同步的数据）
  * @param {*} data
  * @returns
  */
export const projectSyncProjectPage = (data) => post('/r3/project/syncProjectPage', data)


/**
  * 批量重试失败追投批次
  * @param {*} data
  * @returns
  */
export const projectrRetryAddMaterial = (data) => post('/r3/project/retryAddMaterial', data)


/**
  * 追加素材任务分页
  * @param {*} data
  * @returns
  */
export const projectAddMaterialTaskPage = (data) => post('/r3/project/addMaterialTaskPage', data)



/**
  * 获取抖音授权关系
  * @param {*} data
  * @returns
  */
export const globalAdConfigaAwemeAuthList = (data) => post('/r3/globalAdConfig/awemeAuthList', data)



/**
  * 提交批量任务创建链接和商品
  * @param {*} data
  * @returns
  */
export const batchLinkSubmit = (data) => post('/r1/batchLink/submit', data)



/**
  * 批量任务创建链接和商品批次分页列表（按提交时间倒序）
  * @param {*} data
  * @returns
  */
export const batchLinkBatchPage = (data) => get('/r1/batchLink/batchPage', data)



/**
  * 批量任务创建链接和商品明细分页列表
  * @param {*} data
  * @returns
  */
export const batchLinkItemPage = (data) => get('/r1/batchLink/itemPage', data)



/**
  * 批量自动匹配素材
  * @param {*} data
  * @returns
  */
export const projectvideoMatchsubmit = (data) => post('/r3/project/videoMatch/submit', data)



/**
  * 素材自动匹配结果查询（前端轮询）
  * @param {*} data
  * @returns
  */
export const projectvideoMatchresult = (data) => post('/r3/project/videoMatch/result', data)



/**
  * 获取投放账户头像
  * @param {*} data
  * @returns
  */
export const juliangDevUploadAvatar = (data) => post('/r4/juliang-dev/uploadAvatar', data)



/**
  * 批量更新投放账户头像
  * @param {*} data
  * @returns
  */
export const juliangDevUpdateAvatar = (data) => post('/r4/juliang-dev/updateAvatar', data)



/**
  * 批量创建链接和商品时校验专辑ID是否存在
  * @param {*} data
  * @returns
  */
export const bookCheckPlayletIds = (data) => post('/r1/book/checkPlayletIds', data)



/**
  * 修改专辑ID
  * @param {*} data
  * @returns
  */
export const bookUpdatePlayletId = (data) => post('/r1/book/updatePlayletId', data)



/**
  * 按配置批量重试仅 失败 且 response_code in (40100,40110,50000,51010)
  * @param {*} data
  * @returns
  */
export const globalAdConfigRetryByConfigId = (data) => get('/r3/globalAdConfig/retryByConfigId', data)



/**
  * 当前登录人模板分页
  * @param {*} data
  * @returns
  */
export const globalTemplatePage = (data) => get('/r3/globalTemplate/page', data)



/**
  * 模板详情（编辑页回显）
  * @param {*} data
  * @returns
  */
export const globalTemplateDetail = (data) => get('/r3/globalTemplate/detail', data)




/**
  * 编辑模板
  * @param {*} data
  * @returns
  */
export const globalTemplateUpdate = (data) => post('/r3/globalTemplate/update', data)



/**
  * 新建模板
  * @param {*} data
  * @returns
  */
export const globalTemplateAdd = (data) => post('/r3/globalTemplate/add', data)



/**
  * 获取投放项目下素材
  * @param {*} data
  * @returns
  */
export const globalTemplateProjectMaterial = (data) => post('/r3/globalTemplate/projectMaterial', data)










































































